export default __webpack_public_path__ + "static/Natural_Light_Indoor_1920kbps-47ebf3b9525f767316e137c6c9ac09c3.avif";